/// <reference path="../../../../../../typings/index.d.ts" />

module Meevo.Plugins.MeevoMessenger {
    'use strict';

    import IDataMaintenanceInfiniteList = Meevo.Components.BaseClasses.IDataMaintenanceInfiniteList;

    class TextelSearchDeletedConversationListContoller implements ng.IComponentController {
        static $inject = [
            'meevo.AppSettings',
            'meevo.components.common.DataService',
            'meevo.plugins.meevoMessenger.meevoMessengerService',
            'meevo.plugins.meevoMessenger.meevoMessengerApiService',
            'meevo.components.busy.BusyService',
        ];
        
        public selectedConversation: MeevoMessengerConversation;
        public undeleteCallbackOpt: IUndeleteConversationOptions;
        public clientConversationFilter: string;
        public type: UndeleteConversationTypesEnum;
        public userHasAccessToViewPhoneNumber: boolean;

        private clientsDeletedConversation: IDataMaintenanceInfiniteList;
        private selectedClientConversation: MeevoMessengerConversation;
        private employeeConversationFilter: string;
        private employeesDeletedConversation: IDataMaintenanceInfiniteList;
        private selectedEmployeeConversation: MeevoMessengerConversation;

        constructor(
            protected appSettings: Meevo.Components.Common.IAppSettings,
            protected dataService: Meevo.Components.BaseClasses.IDataService,
            protected meevoMessengerService: IMeevoMessengerService,
            protected meevoMessengerApiService: IMeevoMessengerApiService,
            protected busyService: Meevo.Components.Busy.BusyService,
        ) { }

        $onInit() { }

        onClientConversationSelect() {
            this.setSelectedConversationForParent(this.selectedClientConversation);
            this.setUndeleteCallbackOptions({ isClientConversation:  true });

            if (angular.isDefined(this.clientsDeletedConversation)) return;
            this.getClientUndeleteConversation(this.getDefaultConversationBodyRequest());
        }

        onEmployeeConversationSelect() {
            this.setSelectedConversationForParent(this.selectedEmployeeConversation);
            this.setUndeleteCallbackOptions({ isClientConversation: false });

            if (angular.isDefined(this.employeesDeletedConversation)) return;
            this.getEmployeeUndeleteConversation(this.getDefaultConversationBodyRequest(false));
        }

        onClientSearchFilterChanged(conversationFilter) {
            if (!this.userHasAccessToViewPhoneNumber && !isNaN(+conversationFilter)) return;

            this.clientConversationFilter = conversationFilter;
            const bodyRequest = this.meevoMessengerService.getFilterSettingsByFilterOption(_.extendOwn(
                this.getDefaultConversationBodyRequest(), { criteria: { filter: this.clientConversationFilter } }
            ));
            this.getClientUndeleteConversation(bodyRequest);
        }

        onEmployeeSearchFilterChanged(conversationFilter) {
            this.employeeConversationFilter = conversationFilter;
            const bodyRequest = this.meevoMessengerService.getFilterSettingsByFilterOption(_.extendOwn(
                this.getDefaultConversationBodyRequest(false), { criteria: { filter: this.employeeConversationFilter } }
            ), true);
            this.getEmployeeUndeleteConversation(bodyRequest);
        }

        private getClientUndeleteConversation(clientBodyRequest: IConversationBodyRequest) {
            this.busyService.start();
            this.clientsDeletedConversation = new Meevo.Components.BaseClasses.PagedResults(this.dataService, `${this.appSettings.API_ENDPOINTS.meevoMessenger}/Conversation/Deleted`, () => this.busyService.stop());
            this.clientsDeletedConversation.initSearch(clientBodyRequest);
        }

        private getEmployeeUndeleteConversation(employeeBodyRequest: IConversationBodyRequest) {
            this.busyService.start();
            this.employeesDeletedConversation = new Meevo.Components.BaseClasses.PagedResults(this.dataService, `${this.appSettings.API_ENDPOINTS.meevoMessenger}/Conversation/Deleted`, () => this.busyService.stop());
            this.employeesDeletedConversation.initSearch(employeeBodyRequest);
        }

        private onConversationSelected(conversation: MeevoMessengerConversation) {
            this.setSelectedConversationForParent(conversation);
        }

        private setSelectedConversationForParent(conversation: MeevoMessengerConversation) {
            this.selectedConversation = conversation;
        }

        private setUndeleteCallbackOptions(options: IUndeleteConversationOptions) {
            this.undeleteCallbackOpt = { ...this.undeleteCallbackOpt, ...options };
        }

        private getDefaultConversationBodyRequest(isClientList: boolean = true): IConversationBodyRequest {
            return {
                filterPhoneNumber: null,
                filterFullName: null,
                isClientList: isClientList,
                isNewMessage: null,
                isFollowUp: null,
                debug: false,
                dateStart: moment().subtract(3, 'months').toDate(),
                dateEnd: null,
                isLastInbound: null,
                criteria: {
                    filter: null,
                },
                classification: this.getClassification(),
                pageNumber: 0,
                itemsPerPage: 25
            };
        }

        private getClassification() {
            switch (this.type) {
                case UndeleteConversationTypesEnum.Textel:
                    return MeevoMessengerClassificationAPI.TEXTEL
                case  UndeleteConversationTypesEnum.TwoWaySms:
                    return MeevoMessengerClassificationAPI.TWOWAYSMS
                default:
                    return MeevoMessengerClassificationAPI.TEXTEL;
            }

        }

        private get conversationStylesEnum() {
            return DeletedConversationStylesEnum;
        }
    }

    class TextelSearchDeletedConversationListComponent implements angular.IComponentOptions {
        templateUrl = 'app/plugins/meevoMessenger/components/textelSearchDeletedConversationList/textelSearchDeletedConversationList.template.html';
        controller = TextelSearchDeletedConversationListContoller;
        controllerAs = 'vm';
        bindings = {
            selectedConversation: '=',
            undeleteCallbackOpt: '=',
            type: '=',
            userHasAccessToViewPhoneNumber: '<'
        };
    }

    angular.module('meevo.plugins.meevoMessenger')
        .component('textelSearchDeletedConversationList', new TextelSearchDeletedConversationListComponent());

}

